import styled from 'styled-components';

const Heading = styled.h1`
  text-align: center;
  font-family: 'Menlo';
  color: #0f8a19;
`;

export { Heading };


// WEBPACK FOOTER //
// ./src/components/UI/Heading.jsx